module.exports = __webpack_public_path__ + "FixelText-Thin.e718807e808b7fc8875f.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelText/FixelText-Thin.woff2
// module id = ./src/assets/webfonts/fixelText/FixelText-Thin.woff2
// module chunks = styles